import { memo as Memo } from 'react';

//* Components
import CustomLink from '@components/global/CustomLink';

const Nav = Memo((props) => {
	return (
		<CustomLink
			url={props.path}
			content={props.children}
			className={'Link' + props.className}
		/>
	);
});

export default Nav;
